import React, { useState, useRef, useEffect, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import axios from '../../../../../config/axios'
import ApiService from '../../../../../services/ApiService'
import UserContext from '../../../../../contexts/UserContext'
import { FeedbackContext } from '../../../../../contexts/FeedbackContext'
import plus from '../../../../../assets/certificates/AddParameter/blue-plus.svg'
import save from '../../../../../assets/certificates/AddParameter/save.svg'
import trash from '../../../../../assets/equipment/Tables/trash.svg'
import rectangle from '../../../../../assets/equipment/rectangle.svg'
import {
  PageWrapper,
  MainContainer,
  StyledCard,
  StyledCardHeader,
  FormGrid,
  StyledFormGroup,
  MaintenanceServiceWrapper,
  ToggleSwitchContainer,
  SwitchLabel,
  Slider,
  SwitchInput,
  AddMaintenanceButton,
  StyledMaintenanceItem,
  VerificationGroup,
  PeriodicidadeGroup,
  DeleteButton,
  ActionButtons,
  CancelButton,
  SaveButton,
  SubHeaderContainer,
  SectionName,
  LeftSide,
  BreadcrumbsContainer,
  CardTitle,
  ToggleSwitchLabelText,
  NameGroup,
  DropdownContainer,
  DropdownHeader,
  DropdownHeaderSelectedItems,
  DropdownSelectedItemTag,
  DropdownList,
  DropdownListItem,
} from './style'
import CompanySelect from '../../Select/CompanySelect'
import UserSelect from '../../Select/UserSelect'
import InfiniteSelect from '../../../../../components/InfiniteSelect'

interface CompanyItemType {
  id: number
  companyName: string
}

interface UserItemType {
  id: number
  name: string
}

interface MachineTypeItem {
  id: number
  name: string
}

interface MachineLocationItem {
  id: number
  name: string
}

type ServiceProviderType = UserItemType | CompanyItemType | null

interface MaintenanceScheduleItem {
  id: number
  maintenanceName: string
  periodicityValue: string
  periodicityUnit: '' | 'dias' | 'semanas' | 'meses' | 'anos'
  isVerificationEnabled: boolean
  verificationValue: string
  verificationUnit: '' | 'dias' | 'semanas' | 'meses' | 'anos'
  isInternalService: boolean
  selectedServiceProvider: ServiceProviderType
}

interface FormState {
  code: string
  name: string
  model: string
  manufacturer: string
  year: string
  type: MachineTypeItem | null
  dimension: string
  weight: string
  location: MachineLocationItem | null
  costPerHour: string
  capacity: string
  selectedServiceProviders: UserItemType[]
}

const Breadcrumbs: React.FC<{ items: { label: string; path?: string }[] }> = ({
  items,
}) => (
  <BreadcrumbsContainer>
    <ol>
      {items.map((item, index) => (
        <li key={index}>
          {index === items.length - 1 ? (
            <span>{item.label}</span>
          ) : item.path ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </BreadcrumbsContainer>
)

const MaintenanceItemFields: React.FC<{
  item: MaintenanceScheduleItem
  onMaintenanceChange: {
    (
      id: number,
      field: 'isVerificationEnabled' | 'isInternalService',
      value: boolean,
    ): void
    (
      id: number,
      field: 'selectedServiceProvider',
      value: ServiceProviderType,
    ): void
    (
      id: number,
      field:
        | 'periodicityValue'
        | 'periodicityUnit'
        | 'verificationValue'
        | 'verificationUnit'
        | 'maintenanceName',
      value: string,
    ): void
  }
  onRemove: (id: number) => void
}> = ({ item, onMaintenanceChange, onRemove }) => {
  return (
    <StyledMaintenanceItem>
      <NameGroup>
        <label htmlFor={`maintenance-name-${item.id}`}>Nome</label>
        <input
          type='text'
          id={`maintenance-name-${item.id}`}
          value={item.maintenanceName}
          onChange={(e) =>
            onMaintenanceChange(item.id, 'maintenanceName', e.target.value)
          }
          placeholder='Digite aqui'
        />
      </NameGroup>

      <PeriodicidadeGroup>
        <label htmlFor={`periodicity-value-${item.id}`}>Periodicidade</label>
        <div className='input-wrapper'>
          <span className='prefix-text'>A cada</span>
          <input
            type='text'
            id={`periodicity-value-${item.id}`}
            value={item.periodicityValue}
            onChange={(e) =>
              onMaintenanceChange(item.id, 'periodicityValue', e.target.value)
            }
            placeholder='Digite aqui'
          />
          <select
            id={`periodicity-unit-${item.id}`}
            value={item.periodicityUnit}
            onChange={(e) =>
              onMaintenanceChange(
                item.id,
                'periodicityUnit',
                e.target.value as MaintenanceScheduleItem['periodicityUnit'],
              )
            }
          >
            <option value=''>Selecione</option>
            <option value='dias'>Dias</option>
            <option value='semanas'>Semanas</option>
            <option value='meses'>Meses</option>
            <option value='anos'>Anos</option>
          </select>
        </div>
      </PeriodicidadeGroup>

      <img
        src={rectangle}
        alt='Separador'
        style={{
          alignSelf: 'center',
          height: '100%',
          width: '1px',
          backgroundColor: '#E0E0E0',
          justifySelf: 'center',
        }}
      />

      <VerificationGroup>
        <label htmlFor={`verification-toggle-${item.id}`}>Verificação</label>
        <div className='toggle-content-wrapper'>
          <ToggleSwitchContainer>
            <SwitchLabel
              htmlFor={`verification-toggle-${item.id}`}
              className='verification-switch-align'
            >
              <SwitchInput
                type='checkbox'
                id={`verification-toggle-${item.id}`}
                checked={item.isVerificationEnabled}
                onChange={(e) =>
                  onMaintenanceChange(
                    item.id,
                    'isVerificationEnabled',
                    e.target.checked,
                  )
                }
              />
              <Slider className='slider' />
            </SwitchLabel>
          </ToggleSwitchContainer>

          <div className='verification-fields'>
            <span className='prefix-text'>A cada</span>
            <input
              type='text'
              id={`verification-value-${item.id}`}
              value={item.verificationValue}
              onChange={(e) =>
                onMaintenanceChange(
                  item.id,
                  'verificationValue',
                  e.target.value,
                )
              }
              disabled={!item.isVerificationEnabled}
              placeholder='Digite aqui'
            />
            <select
              id={`verification-unit-${item.id}`}
              value={item.verificationUnit}
              onChange={(e) =>
                onMaintenanceChange(
                  item.id,
                  'verificationUnit',
                  e.target.value as MaintenanceScheduleItem['verificationUnit'],
                )
              }
              disabled={!item.isVerificationEnabled}
            >
              <option value=''>Selecione</option>
              <option value='dias'>Dias</option>
              <option value='semanas'>Semanas</option>
              <option value='meses'>Meses</option>
              <option value='anos'>Anos</option>
            </select>
          </div>
        </div>
      </VerificationGroup>

      <DeleteButton type='button' onClick={() => onRemove(item.id)}>
        <img src={trash} alt='Excluir' />
      </DeleteButton>

      <MaintenanceServiceWrapper>
        <ToggleSwitchContainer>
          <ToggleSwitchLabelText>Interno</ToggleSwitchLabelText>
          <SwitchLabel
            htmlFor={`item-isInternalService-${item.id}`}
            className='internal-switch-align'
          >
            <SwitchInput
              type='checkbox'
              id={`item-isInternalService-${item.id}`}
              name={`item-isInternalService-${item.id}`}
              checked={item.isInternalService}
              onChange={(e) => {
                onMaintenanceChange(
                  item.id,
                  'isInternalService',
                  e.target.checked,
                )
                onMaintenanceChange(item.id, 'selectedServiceProvider', null)
              }}
            />
            <Slider className='slider' />
          </SwitchLabel>
        </ToggleSwitchContainer>

        <StyledFormGroup className='flex-grow'>
          {item.isInternalService ? (
            <UserSelect<UserItemType>
              label='Responsável'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`}
              displayField='name'
              value={item.selectedServiceProvider as UserItemType}
              onChange={(user) =>
                onMaintenanceChange(item.id, 'selectedServiceProvider', user)
              }
              permission="production"
            />
          ) : (
            <CompanySelect<CompanyItemType | null>
              label='Responsável'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`}
              displayField='companyName'
              queryParams={{ companyType: 'Fornecedor' }}
              value={item.selectedServiceProvider as CompanyItemType | null}
              onChange={(company) =>
                onMaintenanceChange(item.id, 'selectedServiceProvider', company)
              }
            />
          )}
        </StyledFormGroup>
      </MaintenanceServiceWrapper>
    </StyledMaintenanceItem>
  )
}

const RegisterMachine = () => {
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const { setFeedback } = useContext(FeedbackContext)
  const [form, setForm] = useState<FormState>({
    code: '',
    name: '',
    model: '',
    manufacturer: '',
    year: '',
    type: null,
    dimension: '0',
    weight: '0',
    location: null,
    costPerHour: '0',
    capacity: '0',
    selectedServiceProviders: [],
  })

  const [userSelectKey, setUserSelectKey] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [maintenanceSchedule, setMaintenanceSchedule] = useState<
    MaintenanceScheduleItem[]
  >([
    {
      id: 1,
      maintenanceName: '',
      periodicityValue: '',
      periodicityUnit: '',
      isVerificationEnabled: false,
      verificationValue: '',
      verificationUnit: '',
      isInternalService: false,
      selectedServiceProvider: null,
    },
  ])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  const handleMaintenanceChange = (
    id: number,
    field: keyof MaintenanceScheduleItem,
    value: any,
  ) => {
    setMaintenanceSchedule((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          if (field === 'isVerificationEnabled') {
            return {
              ...item,
              isVerificationEnabled: value as boolean,
              ...(value === false && {
                verificationValue: '',
                verificationUnit: '',
              }),
            }
          }
          if (field === 'isInternalService') {
            return {
              ...item,
              isInternalService: value as boolean,
              selectedServiceProvider: null,
            }
          }
          if (field === 'selectedServiceProvider') {
            return {
              ...item,
              selectedServiceProvider: value as ServiceProviderType,
            }
          }
          return { ...item, [field]: value }
        }
        return item
      }),
    )
  }

  const handleAddServiceProvider = (provider: UserItemType | null) => {
    if (provider) {
      setForm((prev) => {
        if (!prev.selectedServiceProviders.some((p) => p.id === provider.id)) {
          return {
            ...prev,
            selectedServiceProviders: [
              ...prev.selectedServiceProviders,
              provider,
            ],
          }
        }
        return prev
      })
      setUserSelectKey((prevKey) => prevKey + 1)
    }
  }

  const handleRemoveServiceProvider = (providerId: number) => {
    setForm((prev) => ({
      ...prev,
      selectedServiceProviders: prev.selectedServiceProviders.filter(
        (provider) => provider.id !== providerId,
      ),
    }))
  }

  const addMaintenanceItem = () => {
    setMaintenanceSchedule((prev) => [
      ...prev,
      {
        id: prev.length > 0 ? Math.max(...prev.map((i) => i.id)) + 1 : 1,
        maintenanceName: '',
        periodicityValue: '',
        periodicityUnit: '',
        isVerificationEnabled: false,
        verificationValue: '',
        verificationUnit: '',
        isInternalService: false,
        selectedServiceProvider: null,
      },
    ])
  }

  const removeMaintenanceItem = (id: number) => {
    setMaintenanceSchedule((prev) => prev.filter((item) => item.id !== id))
  }

  const handleSubmit = async (e?: React.FormEvent | React.MouseEvent) => {
    if (e) e.preventDefault()
    if (isSubmitting) return

    const token = localStorage.getItem('token')
    if (!token) {
      setFeedback({ isOpen: true, message: 'Sessão expirada ou não logado. Faça login novamente.', statusOk: false })
      return
    }

    if (!form.code || !form.code.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Código" é obrigatório.', statusOk: false })
      return
    }
    if (!form.name || !form.name.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Nome" é obrigatório.', statusOk: false })
      return
    }
    if (!form.model || !form.model.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Modelo" é obrigatório.', statusOk: false })
      return
    }
    if (!form.manufacturer || !form.manufacturer.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Fabricante" é obrigatório.', statusOk: false })
      return
    }
    if (!form.year || !String(form.year).trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Ano" é obrigatório.', statusOk: false })
      return
    }
    if (isNaN(parseInt(form.year))) {
      setFeedback({ isOpen: true, message: 'O campo "Ano" deve ser um número válido.', statusOk: false })
      return
    }
    if (!form.dimension || !form.dimension.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Dimensão" é obrigatório.', statusOk: false })
      return
    }
    if (!form.weight || !String(form.weight).trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Peso" é obrigatório.', statusOk: false })
      return
    }
    if (isNaN(parseFloat(form.weight))) {
      setFeedback({ isOpen: true, message: 'O campo "Peso" deve ser um número válido.', statusOk: false })
      return
    }
    if (!form.costPerHour || !String(form.costPerHour).trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Custo/Hora" é obrigatório.', statusOk: false })
      return
    }
    if (isNaN(parseFloat(form.costPerHour))) {
      setFeedback({ isOpen: true, message: 'O campo "Custo/Hora" deve ser um número válido.', statusOk: false })
      return
    }
    if (!form.capacity || !form.capacity.trim()) {
      setFeedback({ isOpen: true, message: 'O campo "Capacidade" é obrigatório.', statusOk: false })
      return
    }

    const filledMaintenances = maintenanceSchedule.filter(
      (item) => item.maintenanceName && item.maintenanceName.trim() !== '',
    )

    for (const item of filledMaintenances) {
      if (!item.periodicityValue || isNaN(parseFloat(item.periodicityValue))) {
        setFeedback({ isOpen: true, message: `O valor da periodicidade para "${item.maintenanceName}" é obrigatório e deve ser um número válido.`, statusOk: false })
        return
      }
      if (
        item.isVerificationEnabled &&
        (!item.verificationValue || isNaN(parseFloat(item.verificationValue)))
      ) {
        setFeedback({ isOpen: true, message: `O valor da verificação para "${item.maintenanceName}" é obrigatório e deve ser um número válido.`, statusOk: false })
        return
      }
      if (!item.selectedServiceProvider) {
        setFeedback({ isOpen: true, message: `O campo "Responsável" é obrigatório para a manutenção "${item.maintenanceName}".`, statusOk: false })
        return
      }
    }

    const dataToSend = {
      ...form,
      type: form.type?.id.toString() || undefined,
      location: form.location?.id.toString() || undefined,
      year: parseInt(form.year),
      weight: parseFloat(form.weight),
      costPerHour: parseFloat(form.costPerHour),

      selectedServiceProviders: form.selectedServiceProviders.map((p) =>
        p.id.toString(),
      ),

      maintenanceSchedule: filledMaintenances.map((item) => {
        const maintenanceItem = {
          maintenanceName: item.maintenanceName.trim(),
          periodicityValue: item.periodicityValue
            ? parseFloat(item.periodicityValue)
            : 0,
          periodicityUnit: item.periodicityUnit,
          isVerificationEnabled: item.isVerificationEnabled,
          ...(item.isVerificationEnabled && {
            verificationValue: item.verificationValue
              ? parseFloat(item.verificationValue)
              : 0,
            verificationUnit: item.verificationUnit,
          }),
          isInternalService: item.isInternalService,

          selectedServiceProviders: item.selectedServiceProvider
            ? [item.selectedServiceProvider.id.toString()]
            : [],
        }

        return maintenanceItem
      }),
    }

    setIsSubmitting(true)
    try {
      await ApiService.post(
        '/equipment/equipment',
        dataToSend,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setFeedback({ isOpen: true, message: 'Máquina cadastrada com sucesso!', statusOk: true })
      navigate('/panel/equipment')
    } catch (error) {
      setFeedback({
        isOpen: true,
        message: `Erro ao cadastrar máquina: ${
          axios.isAxiosError(error)
            ? error.response?.data?.message || error.message
            : 'Erro na requisição'
        }`,
        statusOk: false,
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  const breadcrumbItems = [
    { label: 'Equipamentos', path: '/panel/equipment' },
    { label: 'Cadastrar máquina' },
  ]

  return (
    <PageWrapper>
      <SubHeaderContainer>
        <LeftSide>
          <SectionName>Cadastrar máquina</SectionName>
        </LeftSide>
        <ActionButtons>
          <CancelButton
            type='button'
            onClick={() => navigate('/panel/equipment')}
            disabled={isSubmitting}
          >
            Cancelar
          </CancelButton>
          <SaveButton
            type='button'
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            <img src={save} alt='Salvar' />
            {isSubmitting ? 'Salvando...' : 'Salvar máquina'}
          </SaveButton>
        </ActionButtons>
      </SubHeaderContainer>

      <Breadcrumbs items={breadcrumbItems} />

      <MainContainer>
        <form onSubmit={handleSubmit}>
          <StyledCard>
            <CardTitle>Identificação</CardTitle>
            <FormGrid cols={3}>
              <StyledFormGroup>
                <label htmlFor='code'>
                  Código <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='code'
                  name='code'
                  value={form.code}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='name'>
                  Nome <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='name'
                  name='name'
                  value={form.name}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='model'>
                  Modelo <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='model'
                  name='model'
                  value={form.model}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='manufacturer'>
                  Fabricante <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='manufacturer'
                  name='manufacturer'
                  value={form.manufacturer}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='year'>
                  Ano <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='number'
                  id='year'
                  name='year'
                  value={form.year}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='1900'
                  max='2100'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <InfiniteSelect
                  label="Tipo"
                  mode="crud"
                  value={form.type}
                  onSelect={(value: MachineTypeItem | null) => setForm({ ...form, type: value })}
                  placeholder="Selecione ou crie um tipo"
                  allowCreate={true}
                  allowDelete={true}
                  allowCascadeDelete={true}
                  cascadeDeleteLabel="Desvincular das máquinas existentes e excluir"
                  showCreateOnlyIfNotExists={true}
                  minCreateLength={2}
                  endpointConfig={{
                    baseUrl: '/equipment',
                    listPath: '/equipment/machine-types',
                    createPath: '/equipment/machine-types',
                    deletePath: '/equipment/machine-types'
                  }}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='dimension'>
                  Dimensão <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='dimension'
                  name='dimension'
                  value={form.dimension}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='weight'>
                  Peso <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='number'
                  step='0.01'
                  id='weight'
                  name='weight'
                  value={form.weight}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='0'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <InfiniteSelect
                  label="Local"
                  mode="crud"
                  value={form.location}
                  onSelect={(value: MachineLocationItem | null) => setForm({ ...form, location: value })}
                  placeholder="Selecione ou crie um local"
                  allowCreate={true}
                  allowDelete={true}
                  allowCascadeDelete={true}
                  cascadeDeleteLabel="Desvincular das máquinas existentes e excluir"
                  showCreateOnlyIfNotExists={true}
                  minCreateLength={2}
                  endpointConfig={{
                    baseUrl: '/equipment',
                    listPath: '/equipment/machine-locations',
                    createPath: '/equipment/machine-locations',
                    deletePath: '/equipment/machine-locations'
                  }}
                />
              </StyledFormGroup>
            </FormGrid>
          </StyledCard>

          <StyledCard>
            <CardTitle>Operação</CardTitle>
            <FormGrid cols={2}>
              <StyledFormGroup>
                <label htmlFor='costPerHour'>
                  Custo/Hora <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='number'
                  step='0.01'
                  id='costPerHour'
                  name='costPerHour'
                  value={form.costPerHour}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                  min='0'
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='capacity'>
                  Capacidade <span style={{ color: '#e53e3e' }}>*</span>
                </label>
                <input
                  type='text'
                  id='capacity'
                  name='capacity'
                  value={form.capacity}
                  onChange={handleChange}
                  placeholder='Digite aqui'
                />
              </StyledFormGroup>
            </FormGrid>
          </StyledCard>

          <StyledCard>
            <CardTitle>Prestador de Serviço</CardTitle>
            <StyledFormGroup>
              <UserSelect<UserItemType>
                key={userSelectKey}
                label=''
                apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`}
                displayField='name'
                value={null}
                onChange={handleAddServiceProvider}
                permission="production"
              />
              <DropdownHeaderSelectedItems>
                {form.selectedServiceProviders.map((provider) => (
                  <DropdownSelectedItemTag key={provider.id}>
                    {provider.name}
                    <button
                      type='button'
                      onClick={(e) => {
                        e.stopPropagation()
                        handleRemoveServiceProvider(provider.id)
                      }}
                    >
                      x
                    </button>
                  </DropdownSelectedItemTag>
                ))}
              </DropdownHeaderSelectedItems>
            </StyledFormGroup>
          </StyledCard>

          <StyledCard>
            <StyledCardHeader>
              <CardTitle isMaintenance>Manutenção periódica</CardTitle>
              <AddMaintenanceButton type='button' onClick={addMaintenanceItem}>
                <img src={plus} alt='Adicionar' />
                Adicionar manutenção
              </AddMaintenanceButton>
            </StyledCardHeader>

            {maintenanceSchedule.map((item) => (
              <MaintenanceItemFields
                key={item.id}
                item={item}
                onMaintenanceChange={handleMaintenanceChange}
                onRemove={removeMaintenanceItem}
              />
            ))}
          </StyledCard>
        </form>
      </MainContainer>
    </PageWrapper>
  )
}

export default RegisterMachine

